import {
  ROLE_ADMIN_USER,
  ROLE_COORDINATOR,
  ROLE_CRUISE_COORDINATOR,
  ROLE_EMPLOYEE_USER,
  ROLE_EXPERIENCES_COORDINATOR,
  ROLE_ICS_STORE_TEAM,
  ROLE_TOUR_COORDINATOR,
} from '~/consts/roles';

import UserService from '../services/UserService';

import BaseStore from './BaseStore';
import SessionStore from './SessionStore';

export default class UserStore extends BaseStore {
  service: UserService;
  sessionError: Error | null;
  sessionStore: SessionStore;

  constructor(userService, sessionStore) {
    super();
    this.service = userService;
    this.sessionError = null;
    this.sessionStore = sessionStore;

    this.resolveSession(null, false);
  }

  isValidRole(account) {
    if (
      (account &&
        !account.roles.includes(ROLE_ADMIN_USER) &&
        !account.roles.includes(ROLE_EMPLOYEE_USER) &&
        !account.roles.includes(ROLE_COORDINATOR) &&
        !account.roles.includes(ROLE_EXPERIENCES_COORDINATOR) &&
        !account.roles.includes(ROLE_ADMIN_USER) &&
        !account.roles.includes(ROLE_ICS_STORE_TEAM) &&
        !account.roles.includes(ROLE_CRUISE_COORDINATOR) &&
        !account.roles.includes(ROLE_TOUR_COORDINATOR)) ||
      !account
    ) {
      return new Error(`You don't have the permissions for this operation`);
    }

    return null;
  }

  loginWithGoogle(options, callback) {
    this.reset();

    this.service.loginWithGoogle(options, (err) => {
      if (err) {
        return callback(err);
      }

      this.resolveSession(callback, true);
    });
  }

  updateProfile(data, callback) {
    this.service.updateProfile(data, callback);
  }

  logout(callback) {
    this.service.logout((err) => {
      if (err) {
        return callback(err);
      }

      this.reset();
      this.emitChange();

      callback();
    });
  }

  resolveSession(callback, force) {
    if (!force && (this.sessionError || !this.sessionStore.empty())) {
      return callback && callback(this.sessionError, this.sessionStore.get());
    }

    this.sessionStore.set({
      loading: true,
      account: null,
    });

    this.service.me((err, account) => {
      if (!err) {
        err = this.isValidRole(account);
      }
      if (err) {
        this.sessionError = err;
        this.sessionStore.set({
          loading: false,
          account: null,
        });
        this.service.delToken();
      } else {
        this.sessionError = null;
        this.sessionStore.set({
          loading: false,
          account,
        });
      }

      if (callback) {
        return callback(this.sessionError, this.sessionStore.get());
      }

      this.emitChange();
    });
  }

  reset() {
    this.sessionError = null;
    this.sessionStore.set({
      loading: false,
      account: null,
    });
  }
}
